import { listSnapshotDetails as entraListSnapshotDetails } from "@/services/api/app/office/entraId/file";
import { listSnapshotDetails as salesforceListSnapshotDetails } from "@/services/api/app/salesforce/recovery/salesforceObject/data-set/file";

export function fetchObjectsMultiPicker(provider) {

  if (provider === 'MICROSOFT' || provider === 'ENTRAID') {
    return ({ search, objectType, snapshotDateTime, pagination = { pageNumber: 1, pageSize: 999, sortBy: 'displayName', sortDescending: false } }) => {
      return entraListSnapshotDetails({
        pagination,
        type: objectType,
        searchTerm: search,
        snapshotDateTime
      });
    };
  }

  if (provider === 'SALESFORCE') {
    return ({ search, snapshotId, pagination = { pageNumber: 1, pageSize: 30, sortBy: 'objectName', sortDescending: false } }) => {
      return salesforceListSnapshotDetails({
        pagination,
        objectType: '1',
        searchTerm: search,
        snapshotId
      });
    };
  }

  return () => Promise.resolve({ result: [] });
}
